module.exports = __webpack_public_path__ + "fd51756c18dc0340e2b04e8888b98f59.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2104_teaser_image.jpg
// module id = 600
// module chunks = 0